import ScrollToTop from "../components/ScrollToTop";
import { Outlet } from "react-router-dom";

const BareLayout = () => {
  return (
    <div className="app-root">
      <ScrollToTop />
      <Outlet />
    </div>
  );
};

export default BareLayout;
